<template>
  <div class="message-board" ref="messageBoard">
    <div class="message-board-shrink-button" @click="shrinkClick">
      <i class="el-icon-d-arrow-right"></i>
    </div>
    <div class="board-left">
      <div style="height:100%;border-right: 1px solid #d8d8d8;float: right;"></div>
      <div class="board-left-title">在线人数（{{peopleOnlineNum}}）</div>
      <div 
        v-for="(item,index) in userOnline" 
        :key="index"
       >
        <div  
          :class="[{ 'isClickList': item.id == currentTalk.id }, 'board-userList']"  :title="item.name"
          @click="talkTo(item, index)">
            <!-- <span class="userListName">{{ item.name }}</span>
            <span class="userListNum" v-if="item.num !== 0">{{ item.num }}</span> -->

            <span class="userListName">
              <span class="user-circle"></span> {{item.loginId}} 
              <span v-show="item.loginId == currentUserInfo.loginId" class="el-icon-star-off">  </span>
              <span class="userListNum" v-if="item.num != 0"> <div class="tips">{{ item.num }}</div> </span>
            </span>
            <span class="user-title"> {{ item.title }}</span>

          </div>
        
      </div>
    </div>
    <div class="board-right">
      <div style="height: 76%;overflow: auto;" ref="scrollDiv">
        <div class="board-right-title">{{currentTalk.name}}</div>
        <div class="board-right-content" v-for="(item,index) in currentTalk.boardInfo" :key="index">
          <div :class="[ {'self-message' : item.from == currentUserInfo.loginId}]" >
            <div class="board-right-text">
              <span>
                {{item.text}}
              </span>
            </div>
            <div class="board-right-time">
              <div>
                {{item.date}}
              </div>
            </div>
            <!-- <div style="margin-top:10px;border-bottom: 1px dashed #d3d3d3;"></div> -->
          </div>
        </div>
      </div>
      <div class="board-right-textarea">
        <!-- <div class="board-right-textarea-title">您的留言:</div> -->
        <el-input
          type="textarea"
          :autosize="{ minRows: 3, maxRows: 4}"
          placeholder="请输入内容"
          v-model="textarea">
        </el-input>
        <el-button size="mini" type="primary" style="margin-top:10px" @click="submitTextarea">发表</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  export default {
    data() {
      return {
        talkNum:0,//左侧点击列表高亮
        talkName:"所有人",//聊天框与谁聊天
        peopleOnlineNum:0,//在线人数

        closeBoard:0,

        currentTalk:{},
        
        visible:false,
        textarea:"",
        replyTextarea:"",
        userOnline:[],
        boardInfo:[],

        socket:"",
        currentUserInfo:{
          loginId: JSON.parse(window.sessionStorage.getItem('userContext')).loginId,

        },
      };
    },
    methods: {
      // 滚动到底部
      handleScrollBottom() {
        this.$nextTick(() => {
          let scrollElem = this.$refs.scrollDiv;
          scrollElem.scrollTo({ top: scrollElem .scrollHeight, behavior: 'smooth' });
        });
      },
      talkTo(obj){
        obj.num = 0;
        this.currentTalk = obj;
      },
      shrinkClick(){
        //this.websock.close()
        this.closeBoard+=1;
        // console.log("123");
        this.$emit("closeBoard",this.closeBoard);
      },
      submitReply(i){
        console.log(this.replyTextarea);
        this.$refs.reference1[i].doClose();
      },
      handerClick(i){
        this.replyTextarea = "";
      },
      submitTextarea(){

        if (this.textarea == ''|| this.textarea.trim() == '') {
          this.textarea = ''
          return
        }

        let obj = {
          from:this.currentUserInfo.loginId,
          to:this.currentTalk.id,
          text:this.textarea,
          date:this.getDate(),
          tenantId:window.sessionStorage.getItem('tenantId')
        };

        if (this.currentTalk.id != '-1') {
          this.currentTalk.boardInfo.push(obj)
        }        

        if (this.currentTalk.id != this.currentUserInfo.loginId) {
          this.websocketsend(obj);
        }
        this.textarea = ''
        this.handleScrollBottom();
      },
      getDate(time) {
        var date = time ?  new Date(time) : new Date();
        var y = date.getFullYear()
        var m = date.getMonth() + 1
        m = m < 10 ? '0' + m : m
        var d = date.getDate()
        d = d < 10 ? '0' + d : d;
        var h = date.getHours()
        h = h < 10 ? '0' + h : h
        var minute = date.getMinutes()
        minute = minute < 10 ? '0' + minute : minute
        // var s = date.getSeconds()
        // s = s < 10 ? '0' + s : s
        return y + '-' + m + '-' + d + ' ' + h + ':' + minute  
      },

      initWebSocket(){ //初始化weosocket
        var session = window.sessionStorage.getItem('userContext');
        session = JSON.parse(session);
        // const wsuri = "ws://192.168.1.159:9001/message/websocket"+ "/" + window.sessionStorage.getItem('tenantId') + "/" + session.loginId;
        // this.websock = new WebSocket(wsuri);
        const wsurl = 'ws:' + this.resURL+ "/message/websocket"+ "/" + window.sessionStorage.getItem('tenantId') + "/" + this.currentUserInfo.loginId;
        this.websock = new WebSocket(wsurl);

        this.websock.onmessage = this.websocketonmessage;
        this.websock.onopen = this.websocketonopen;
        this.websock.onerror = this.websocketonerror;
        this.websock.onclose = this.websocketclose;
      },
      websocketonopen(){ //连接建立之后执行send方法发送数据
        //let actions = {"test":"12345"};
        //this.websocketsend(JSON.stringify(actions));
        //console.log("socket连接成功")
      },
      websocketonerror(e){//连接建立失败重连
        this.initWebSocket();
        // console.log(e);
      },
      websocketonmessage(e){ //数据接收
        let redata = JSON.parse(e.data);
        let session = window.sessionStorage.getItem('userContext');
        session = JSON.parse(session);
        let userId = session.loginId;
        if(redata.to == 0 || redata.to == "-2" ){//上线提醒
          //console.log(redata.to);
          let arr = redata.text.split(';');
          // arr.length = arr.length -1;
          arr.pop();
          this.peopleOnlineNum = arr.length;
          this.userOnline = [{ id: '-1',num:0, name: '所有人', loginId: '所有人', title: 'All', boardInfo: [] }, ...this.allUser.filter(i => arr.includes(i.loginId))]
          if (!this.currentTalk.hasOwnProperty('id')) {
            this.currentTalk = this.userOnline[0];
          }
        } 
        else {
          const id = redata.to == '-1' ? redata.to : redata.from;
          const item = this.userOnline.find(i => i.id == id);
          redata.date = redata.date.substring(0,redata.date.lastIndexOf(':'))
          item.boardInfo.push(redata);
          if (this.currentTalk.id != redata.to) {
            item.num ++
          }
          this.handleScrollBottom();
        };
      },
      websocketsend(Data){//数据发送
        this.websock.send(JSON.stringify(Data));
        this.textarea = "";
      },
      websocketclose(e){  //关闭
        console.log('断开连接',e);
      },

      getCeshi(){
        axios.get("message/getloginid").then((res) => {
          console.log(res);
        });
      },

      getAllUser() {
        // let session = window.sessionStorage.getItem('userContext');
        // session = JSON.parse(session);
        // let userId = session.loginId;
        axios.get("pmdm/admin/user/getUsers?loginId=").then((res) => {

          this.resURL = (res.request.responseURL).split('/pmdm')[0].split('http://')[1];
          if (process.env.NODE_ENV !== "development") {
            this.resURL = this.resURL.split('/api')[0]
          }
          // console.log(this.resURL,this.resURL = this.resURL.split('/api')[0]);
          this.allUser = res.data.object.users.map(i =>(
            {
              id:i.loginId,
              name:i.displayUserName,
              num:0,
              loginId:i.loginId,
              title:i.userName,
              boardInfo:[]
            }
          ))
         
          this.initWebSocket();
        })
      },
    },
    created() {
      this.getAllUser();
    },
 
    destroyed() {
      this.websock.close() //离开路由之后断开websocket连接
    },

  }
</script>

<style scoped>
.message-board {
  width: 100%;
  height: 100%;
  /* background: #f5f5d5; */
  background: #F7F7F7;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 200;
  font-size: 14px;
}
.message-board-shrink-button {
  width: 20px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border-radius:0 4px 4px 0;
  position: absolute;
  top: 50%;
  left: 0;
  margin-top: -40px;
  cursor: pointer;
  background: #66B1FF;
  color: #fff;
  z-index: 600;
  transition: 0.4s;
}
.message-board-shrink-button:hover {
  color: #000;
  background: #4588f9;
  color: #fff;
}
.board-left {
  width: 25%;
  height: 100%;
  float: left;
  overflow: auto;
  /* background: #f6f1e7; */
  /* background: #e0dfcc; */
}
.board-left-title {
  padding: 6px;;
  /* border-bottom: 1px solid #d3d3d3; */
  font-size: 16px;
  margin: 15px 3px;
  height: 26px;
  overflow: hidden;
}
.board-userList {
  padding: 8px 3px;
  /* background: #d2e3f5;
  border-radius: 4px; */
  margin: 3px 15px;
  overflow: hidden;
  transition: 0.4s;
  border-radius: 4px;
}

.board-userList:hover{
  background: #4588f9;
  color: #E7F1F6;
}

.user-circle {
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background: #13ce66;
  display: inline-block;
}
.userListName {
  width: 100%;
  /* width: 80%; */
  /* float: left; */
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
  margin-left: 3px;
  display: block;
}
.user-title{
  font-size: 12px;color: #d3d3d3;margin-left: 15px;
  transition: 0.4s;
  display: block;
  cursor: pointer;
}
.user-title:hover{
  color: #F7F7F7;
}
.userListNum {
 
  color: #fff;
  padding: 2px;
  font-size: 10px;
  /* float: right; */
}
.tips{
  width: 16px;
  height: 16px;
  background: #f56c6c;
  border-radius: 8px;
  display: block;
  line-height: 16px;
  text-align: center;
  display: inline-block;
}

.isClickList {
  /* padding: 4px;;
  background: rgba(69,136,249,0.7);
  border-radius: 4px;
  margin: 4px; */
  background: #4588f9;
  overflow: hidden;
  color: #E7F1F6;
}
.isClickList>.user-title{
  color: #E7F1F6;
}
.board-userList.self {
  background: #13ce66;
  color: #E7F1F6;
}

.board-right {
  width: 75%;
  height: 100%;
  float: left;
}
.board-right-title {
  padding: 16px;
  border-bottom: 1px solid #d3d3d3;
  font-size: 14px;
  margin-bottom: 10px;
  /* height: 32px;
  line-height: 32px; */
  /* overflow: hidden; */
}
.board-right-content {
  padding: 0 10px 10px 10px;
}
.board-right-name {
    color: #2b2b2b;
    font-weight: 700;
    font-size: 12px;
}
.board-right-name p{
    line-height: 12px;
    margin: 0 0 10px 0;
}

.board-right-text{
  width: 100%;
  overflow: hidden;
}
.board-right-text span{
  background: #fff;
  padding: 6px;;
  border-radius: 4px;
  font-size: 14px;
  margin-right: 20px;
  float: left;
}

.board-right-time {
  font-size: 12px;
  margin-top: 10px;
  /* text-align: right; */
  color: #C0C4CC;
}

.self-message>.board-right-text span{
  background: #4588f9;
  color: #fff;
  float: right;
}
.self-message>.board-right-time{
  text-align: right;
}
.board-right-textarea {
  /* background: #f0f0c0; */
  padding: 4px;;
  margin: 4px;;
  border-radius: 4px;
}
.board-right-textarea-title {
  font-weight: 700;
}
</style>